/**
 * Created by mac on 12/7/20
 */

const Field = function (slot, levelContent, options) {
    cleverapps.EventEmitter.call(this);

    options = options || {};

    this.slot = slot;

    this.families = options.families;

    this.unitsSkin = options.units;
    this.tilesSkin = options.tiles;

    this.tiles = [];
    this.units = [];

    this.width = levelContent.width;
    this.height = levelContent.height;

    this.units = [...Array(this.height)].map(() => Array(this.width).fill());

    this.onAddUnit = function () {};
    this.onAnimationsAdd = function () {};
    this.onMove = function () {};
    this.onDiscoverMapView = function () {};
    this.stopDragging = function () {};
    this.onUnitFreshListener = function () {};

    this.fakeUnits = Field.ReadDefaults(levelContent.field);

    if (cleverapps.config.debugMode && !cleverapps.config.editorMode) {
        this.orangery = new Orangery(FlatMapOrangery);
    }

    if (!cleverapps.config.adminMode) {
        this.smile = new Smile(this.getSmiles.bind(this), {
            interval: cleverapps.parseInterval("15 seconds")
        });
        this.smile.start();
    }
};

Field.prototype = Object.create(cleverapps.EventEmitter.prototype);
Field.prototype.constructor = Field;

Field.prototype.loadUnits = function (isNewGame) {
    const storedUnits = [];

    this.iterate((x, y) => {
        if (isNewGame) {
            const fakeUnit = this.getFakeUnit(x, y);
            if (fakeUnit) {
                storedUnits.push({ x, y, data: fakeUnit });
            }
            return;
        }

        const data = FlatMapSaver.loadUnit(this, x, y);
        if (data) {
            if (data.fog) {
                const fakeUnit = this.getFakeUnit(x, y);
                if (fakeUnit) {
                    storedUnits.push({ x, y, data: fakeUnit });
                }
            } else {
                storedUnits.push({ x, y, data });
            }
        }
    });

    storedUnits.forEach((info) => {
        info.data = Families.processUnknown(info.data, Merge2.current.families);
    });

    storedUnits.sort((unit1, unit2) => unit1.data.code.localeCompare(unit2.data.code) || (unit2.data.stage - unit1.data.stage));

    storedUnits.forEach((info) => {
        this.createUnit(info.x, info.y, info.data);
    });

    this.iterateUnits((x, y, unit) => {
        const grounded = unit.findComponent(Grounded);
        if (grounded) {
            grounded.updateState();
        }
    });
};

Field.prototype.saveUnits = function () {
    this.iterateUnits((x, y, unit) => {
        this.saveUnit(unit);
    });
};

Field.prototype.saveUnit = function (unit) {
    if (cleverapps.config.adminMode || cleverapps.config.editorMode) {
        return;
    }

    if (unit.isLifted() || Unit.DISABLED_CODES[unit.code]) {
        return;
    }

    if (!cleverapps.config.saveUnitsEnabled) {
        return;
    }

    let info = unit.getInfo();

    if (info.code === "unknown") {
        info = info._data;
        if (!info) {
            return;
        }
    }

    FlatMapSaver.saveUnit(this, unit.x, unit.y, info);
};

Field.prototype.eraseUnit = function (unit) {
    if (cleverapps.config.adminMode || cleverapps.config.editorMode) {
        return;
    }

    FlatMapSaver.removeUnit(this, unit.x, unit.y);
};

Field.prototype.stop = function () {
    runCleaners(this);

    this.stopped = true;

    this.listAvailableUnits().forEach((unit) => {
        unit.destructor();
    });

    if (this.smile) {
        this.smile.stop();
    }

    this.onUnitFreshListener = function () {};

    this.trigger("stop");
};

Field.prototype.onUnitFresh = function (unit) {
    this.onUnitFreshListener(unit);
};

Field.prototype.onUnitRemoved = function (unit) {
    const selection = this.currentSelection;

    if (selection && unit.x === selection.x && unit.y === selection.y) {
        this.hideSelect();
    }

    this.trigger("onUnitRemoved", unit);
};

Field.prototype.onUnitAvailable = function (unit) {
    cleverapps.tutorial.trigger("onUnitAvailable", unit);
    this.trigger("onUnitAvailable", unit);
};

Field.prototype.getMapView = function () {
    return this.onDiscoverMapView();
};

Field.prototype.iterate = function (iterator) {
    for (let y = 0; y < this.height; y++) {
        for (let x = 0; x < this.width; x++) {
            iterator(x, y);
        }
    }
};

Field.prototype.iterateUnits = function (iterator) {
    for (let y = 0; y < this.height; y++) {
        for (let x = 0; x < this.width; x++) {
            const unit = this.units[y][x];
            if (unit) {
                iterator(x, y, unit);
            }
        }
    }
};

Field.prototype.isValid = function (x, y) {
    return x >= 0 && x < this.width && y >= 0 && y < this.height;
};

Field.prototype.addUnit = function (x, y, unit) {
    this.units[y][x] = unit;
};

Field.prototype.removeUnit = function (x, y) {
    if (this.dragging && this.dragging.x === x && this.dragging.y === y) {
        cleverapps.throwAsync("Remove draggging unit");
    }

    this.units[y][x] = undefined;
};

Field.prototype.getUnit = function (x, y) {
    return this.units[y] && this.units[y][x];
};

Field.prototype.iterateBfs = function (x, y, iterator) {
    const dirs = Field.NEIGHBORS;
    const queue = [{ x, y, step: 0 }];

    const used = {};
    used[this.getPositionKey(x, y)] = true;

    let pointer = 0;
    while (pointer < queue.length) {
        const p = queue[pointer++];

        if (iterator(p)) {
            return;
        }

        for (let i = 0; i < dirs.length; i++) {
            const tx = p.x + dirs[i].x;
            const ty = p.y + dirs[i].y;

            const key = this.getPositionKey(tx, ty);
            if (!used[key]) {
                used[key] = true;

                if (tx >= 0 && tx < this.width && ty >= 0 && ty < this.height) {
                    queue.push({ x: tx, y: ty, step: p.step + 1 });
                }
            }
        }
    }
};

Field.prototype.iterateNeighbours = function (x, y, iterator) {
    const dirs = Field.NEIGHBORS;

    for (let i = 0; i < dirs.length; i++) {
        const dir = dirs[i];

        const tx = x + dir.x;
        const ty = y + dir.y;

        if (tx >= 0 && tx < this.width && ty >= 0 && ty < this.height) {
            iterator({ x: tx, y: ty });
        }
    }
};

Field.prototype.getPositionKey = function (x, y) {
    return x + y * this.width;
};

Field.prototype.getScreenCenterCell = function () {
    return cc.p(Math.round(this.width / 2), Math.round(this.height / 2));
};

Field.prototype.listAvailableUnits = function (filter) {
    const units = [];

    if (filter && typeof filter !== "function") {
        filter = Unit.IsApplicable.bind(Unit, filter);
    }

    for (let y = 0; y < this.getHeight(); y++) {
        for (let x = 0; x < this.getWidth(); x++) {
            const unit = this.getUnit(x, y);
            if (unit) {
                const grounded = unit.findComponent(Grounded);
                if (!grounded || grounded.isOpened()) {
                    if (!filter || filter(unit)) {
                        units.push(unit);
                    }
                }
            }
        }
    }

    return units;
};

Field.prototype.findUnitToRemove = function () {
    const units = this.listAvailableUnits((unit) => Families[unit.code].type === "resource"
        && unit.isSellable() && !unit.customerMark && unit.getData().selectable !== false);

    return units.sort((a, b) => a.stage - b.stage)[0];
};

Field.prototype.isEmpty = function (x, y) {
    return this.isValid(x, y) && !this.getUnit(x, y);
};

Field.prototype.countEmptySlots = function () {
    let amount = 0;
    for (let y = 0; y < this.getHeight(); y++) {
        for (let x = 0; x < this.getWidth(); x++) {
            if (this.isEmpty(x, y)) {
                amount++;
            }
        }
    }
    return amount;
};

Field.prototype.findEmptySlot = function (x, y) {
    const directions = Field.NEIGHBORS;

    PseudoRandom.GET().shuffle(directions);

    for (let d = 0; d < 100; d++) {
        for (let dd = 0; dd <= d; dd++) {
            for (let j = 0; j < 2; j++) {
                let rd = dd;
                if (j > 0) {
                    if (dd === 0) {
                        continue;
                    }
                    rd = -dd;
                }
                for (let i = 0; i < directions.length; i++) {
                    const nx = x + ((directions[i].x === 0) ? rd : (directions[i].x * d));
                    const ny = y + ((directions[i].y === 0) ? rd : (directions[i].y * d));

                    if (this.isEmpty(nx, ny)) {
                        return cc.p(nx, ny);
                    }
                }
            }
        }
    }
};

Field.prototype.getWidth = function () {
    return this.width;
};

Field.prototype.getHeight = function () {
    return this.height;
};

Field.prototype.setDragging = function (unit) {
    if (this.dragging === unit) {
        return;
    }
    this.dragging = unit;
    this.trigger("changeDragging", unit);
};

Field.prototype.createUnit = function (x, y, data) {
    if (!this.families[data.code] || !Families[data.code] || !Families[data.code].units[data.stage]) {
        data = {
            code: "unknown",
            stage: 0,
            _data: data
        };
    }

    data._fromSave = true;

    const unit = new Unit(data, x, y);
    unit.setPosition(x, y);
    this.addUnit(x, y, unit);
    this.onAddUnit(x, y, unit);
    return unit;
};

Field.prototype.getSmiles = function () {
    return this.listAvailableUnits()
        .filter((unit) => unit.canSmile());
};

Field.prototype.selectUnit = function (unit, isDragging) {
    if (unit.getData().selectable === false) {
        return;
    }

    this.selectedUnit = unit;
    this.forgetRemoved();

    this.lastSelection = this.currentSelection;
    this.currentSelection = { x: unit.x, y: unit.y };

    this.updateUnitSelection(isDragging);
};

Field.prototype.rememberRemoved = function (unit) {
    this.removedUnit = new RemovedUnit(unit);
};

Field.prototype.forgetRemoved = function () {
    this.removedUnit = undefined;
};

Field.prototype.undoRemove = function (view) {
    const removed = this.removedUnit;
    if (!removed || !removed.canUndo(view)) {
        return;
    }

    this.selectUnit(removed.undo());
};

Field.prototype.hideSelect = function () {
    this.currentSelection = undefined;
    this.selectedUnit = undefined;

    this.updateUnitSelection();
};

Field.prototype.updateUnitSelection = function (isDragging) {
    this.trigger("unitSelectionChanged", this.selectedUnit, isDragging);
    cleverapps.tutorial.trigger("unitSelectionChanged", this.selectedUnit);
};

Field.prototype.getFakeUnit = function (x, y) {
    return this.fakeUnits[x] && this.fakeUnits[x][y];
};

Field.prototype.listFakeUnits = function (filter) {
    if (filter && typeof filter !== "function") {
        filter = Unit.IsApplicable.bind(Unit, filter);
    }

    const units = [];

    for (const row in this.fakeUnits) {
        for (const col in this.fakeUnits[row]) {
            if (!filter || filter(this.fakeUnits[row][col])) {
                units.push(this.fakeUnits[row][col]);
            }
        }
    }

    return units;
};

Field.NEIGHBORS = [{
    y: 0,
    x: -1
}, {
    y: 1,
    x: 0
}, {
    y: -1,
    x: 0
}, {
    y: 0,
    x: 1
}];

Field.DROP_TARGETS = [];

Field.mapEvent = function (type, options) {
    if (!Merge2.current || Merge2.current.field.stopped) {
        cleverapps.throwAsync(`throw event after field is stopped ${type}`);
        return;
    }

    cleverapps.eventBus.trigger("mapEvent", type, options);

    cleverapps.eventBus.trigger(`weeklygoals-${type}`);

    if (type === Field.CLICK_UNIT) {
        cleverapps.tutorial.trigger(Field.CLICK_UNIT, options.affected);
    }

    if (type === Field.SPAWN) {
        if (options.unit) {
            const unit = options.unit;
            const family = Families[unit.code];

            if (unit.stage >= family.units.length - 5 && family.type === "resource") {
                cleverapps.eventBus.trigger("ONE_OF_TWO_LAST_UNIT_STAGES_SPAWNED");
            }
        }
    }
};

Field.ReadDefaults = function (defaults) {
    const units = {};
    defaults.forEach((item) => {
        item = Field.ReadMapUnit(item);
        if (!item) {
            return;
        }

        const x = item.x;
        const y = item.y;

        if (units[x] === undefined) {
            units[x] = {};
        }

        units[x][y] = item;
    });
    return units;
};

Field.ReadMapUnit = function (item) {
    item = cleverapps.clone(item, true);

    const family = Families[item.code];
    if (!family) {
        cleverapps.throwAsync(`unknown unit while reading map data ${item.code}`);
        return;
    }

    const data = family.units[item.stage];

    item.type = family.type;

    if (item.grounded !== false && data.source) {
        item.grounded = true;
    }

    item.fresh = true;

    return item;
};

Field.MERGE = "merge";
Field.SPAWN = "spawn";
Field.HARVEST = "harvest";
Field.BUY_FREE_UNIT = "buyfreeunit";
Field.CLICK_UNIT = "clickunit";
Field.DRAG = "drag";
Field.COMPLETE_ORDER = "complete_order";
Field.OPEN_UNIT = "open_unit";
Field.REFILL = "refill";
Field.BEFORE_EXCHANGE = "before_exchange";
Field.EXCHANGE = "exchange";
Field.RECIPE_NEW = "recipe_new";
Field.RECIPE_CHANGE = "recipe_change_ingredients";
